// -- Setup --------------------------------------------------------------------
    import React from 'react';
    import { Link } from 'react-router-dom';
// -----------------------------------------------------------------------------

// -- Components ---------------------------------------------------------------
// -----------------------------------------------------------------------------


class MenuItemChildren extends React.Component{
    constructor(props){
        super(props);
        this.changePage = this.changePage.bind(this);
    }
    changePage(e){
        this.props.changePage(e.currentTarget.dataset.pageid);
    }
    render(){
        const linkTo = (this.props.name == 'home') ? this.props.basePath : this.props.name;
        let children = [];
        this.props.children.map((item) => {
            children.push(
                <li>
                    <Link to={item.name} onClick={this.changePage} data-pageid={item.id}>
                        {item.title}
                    </Link>
                </li>
            )
        })
        return(
            <li>
                <Link to={linkTo} onClick={this.changePage} data-pageid={this.props.id}>
                    {this.props.title}
                </Link>
                <ul>
                    {children}
                </ul>
            </li>
        )
    }
}

export default MenuItemChildren;
